import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function BtcIcon({
  width = 50,
  height = 50,
  fill = 'white',
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill={fill}
      {...props}
    >
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <g clipPath="url(#prefix__clip0_4525_103900)">
        <path
          d="M20.291 13.29c.239-1.597-.977-2.455-2.64-3.028l.54-2.163-1.317-.328-.525 2.106a54.647 54.647 0 00-1.055-.248l.529-2.12-1.316-.328-.54 2.162c-.286-.065-.568-.13-.84-.197l.001-.007-1.816-.454-.35 1.407s.977.224.956.237c.533.133.63.486.614.766l-.614 2.465c.036.009.084.022.136.044l-.139-.035-.86 3.452c-.066.162-.232.406-.604.313.013.02-.957-.239-.957-.239l-.654 1.508 1.713.427c.32.08.632.163.94.242l-.546 2.188 1.316.328.54-2.165c.359.098.707.188 1.049.273l-.538 2.154 1.317.328.545-2.183c2.245.425 3.933.253 4.644-1.778.573-1.635-.029-2.578-1.21-3.193.86-.199 1.509-.764 1.681-1.934zm-3.009 4.22c-.407 1.634-3.16.75-4.052.529l.723-2.899c.892.223 3.755.664 3.33 2.37zm.408-4.243c-.372 1.487-2.663.731-3.406.546l.655-2.629c.744.185 3.137.531 2.75 2.083z"
          fill="#F7931A"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_4525_103900">
          <path fill="#fff" transform="translate(3 3)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoBtcIcon = React.memo(BtcIcon);
export default MemoBtcIcon;
